import { ADVANCE_SEARCH_ERROR, ADVANCE_SEARCH_REQUEST, ADVANCE_SEARCH_SUCCESS } from "./ActionType";

const initialState = {
    isRequest: false,
    isSuccess: false,
    isError: false,
    advanceSearch: null,
    error: null,
    requestId: null,
  };
  
  const advanceSearchStoreReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADVANCE_SEARCH_REQUEST:
          return {
            ...state,
            isRequest: true,
            isSuccess: false,
            isError: false,
            advanceSearch: null,
            error: null,
            requestId: action.meta?.requestId ?? null,
          };
        case ADVANCE_SEARCH_SUCCESS:
          if (action.meta?.requestId !== state.requestId) {
            return state;
          }
          return {
            ...state,
            isRequest: false,
            isSuccess: true,
            isError: false,
            advanceSearch: action.payload,
            error: null,
          };
        case ADVANCE_SEARCH_ERROR:
          if (action.meta?.requestId !== state.requestId) {
            return state;
          }
          return {
            ...state,
            isRequest: false,
            isSuccess: false,
            isError: true,
            advanceSearch: null,
            error: action.payload,
          };
          default:
            return state;
        }
  }

  export default advanceSearchStoreReducer;
